import { default as aboutzL6dbjcv1TMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsRJHDZhNaEPMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93hXFg4J2ZzFMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample3Mkx9ZUKj0Meta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products5gzsCRrHzQMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_937LUUIFaYPgMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view5sJqjGoTJ8Meta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexrdfjkdaF38Meta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93tCcJi9ibGHMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index1Y8Jigd3FjMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93IEhVgmD9BNMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexqcGv4qivP6Meta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsiYqxzteerEMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsRd3YMgAod9Meta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsPVWo33CLYCMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93GuT099tjfVMeta } from "/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexHrgUap51XUMeta } from "/tmp/build_fab81756/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirm0e2ukb5kD6Meta } from "/tmp/build_fab81756/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmcmKuoKy46qMeta } from "/tmp/build_fab81756/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarFEhZQt8hTRMeta } from "/tmp/build_fab81756/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatzI7oCAjXTCMeta } from "/tmp/build_fab81756/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutsUNhtsIMjFMeta } from "/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedBVjMiyCYpCMeta } from "/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersdVNsEdY9KbMeta } from "/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93aWVVoeHjtCMeta } from "/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editwm8Rc3FuXcMeta } from "/tmp/build_fab81756/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93pPWgaBvoJzMeta } from "/tmp/build_fab81756/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communitySVCQQgPiZIMeta } from "/tmp/build_fab81756/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_930KirG82dhIMeta } from "/tmp/build_fab81756/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93WicbdM3leLMeta } from "/tmp/build_fab81756/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboard9TBXVxXfuXMeta } from "/tmp/build_fab81756/pages/[studio_url]/dashboard.vue?macro=true";
import { default as index8fr5Wy014MMeta } from "/tmp/build_fab81756/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkout5yAwwUOS9pMeta } from "/tmp/build_fab81756/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productIOiJWUuie9Meta } from "/tmp/build_fab81756/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsgadYNYFDBlMeta } from "/tmp/build_fab81756/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93xjURLsQv7BMeta } from "/tmp/build_fab81756/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexSCYdXcbwtpMeta } from "/tmp/build_fab81756/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93zFOdLSiCh0Meta } from "/tmp/build_fab81756/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_9391HTMc7WgLMeta } from "/tmp/build_fab81756/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexUagp3ksqr2Meta } from "/tmp/build_fab81756/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93tmeVfj9ITgMeta } from "/tmp/build_fab81756/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinnApj9eR1g6Meta } from "/tmp/build_fab81756/pages/[studio_url]/join.vue?macro=true";
import { default as loginSFIwNITSHdMeta } from "/tmp/build_fab81756/pages/[studio_url]/login.vue?macro=true";
import { default as logoutPxUffrDM3VMeta } from "/tmp/build_fab81756/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93bFCnsGsutaMeta } from "/tmp/build_fab81756/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_937cmzG0IosMMeta } from "/tmp/build_fab81756/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93GbJSZHx0XtMeta } from "/tmp/build_fab81756/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesizqu9VGMEBMeta } from "/tmp/build_fab81756/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosmP4XtqtorIMeta } from "/tmp/build_fab81756/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinN9ax6h6hmEMeta } from "/tmp/build_fab81756/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93aWvelkobaeMeta } from "/tmp/build_fab81756/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexXzDhXpbB8AMeta } from "/tmp/build_fab81756/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexRICI8mWWF5Meta } from "/tmp/build_fab81756/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutuPpejbz8G3Meta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45content0VXw1TdU8aMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsdMUKHFRSLIMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93G7K2jttqWWMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplelbrYO7V0jbMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productstAZd4d1MEaMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_930TUIYaddVAMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewxeHnFtquJGMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index7jflFm5Y4IMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_938LT7BxRnt9Meta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexghpLJ2P8UqMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_935hu1MQs3kmMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexZ1cR83zT3XMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessions2dDiUYVWvwMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsjQlWEJLddBMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsv8vJun0SANMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93Km9ZTzz2rpMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexxIzAQadWRRMeta } from "/tmp/build_fab81756/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexbp89oZ7HaPMeta } from "/tmp/build_fab81756/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesxRvq2Vuo6EMeta } from "/tmp/build_fab81756/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsFT80ytd6Q5Meta } from "/tmp/build_fab81756/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93oATx07q8alMeta } from "/tmp/build_fab81756/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93uDS3kvjXTBMeta } from "/tmp/build_fab81756/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetfiR096vBnkMeta } from "/tmp/build_fab81756/pages/[studio_url]/reset.vue?macro=true";
import { default as shopkZhkXsR06TMeta } from "/tmp/build_fab81756/pages/[studio_url]/shop.vue?macro=true";
import { default as signupalO9ghSRF7Meta } from "/tmp/build_fab81756/pages/[studio_url]/signup.vue?macro=true";
import { default as livegqbt4TfMifMeta } from "/tmp/build_fab81756/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipshPujE78ltfMeta } from "/tmp/build_fab81756/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93tBjq4A2ZdGMeta } from "/tmp/build_fab81756/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactpwYxBI7i8WMeta } from "/tmp/build_fab81756/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullurkQ9Ol6MoMeta } from "/tmp/build_fab81756/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93GuT099tjfVMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93GuT099tjfVMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93GuT099tjfVMeta || {},
    alias: _91product_id_93GuT099tjfVMeta?.alias || [],
    redirect: _91product_id_93GuT099tjfVMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutzL6dbjcv1TMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutzL6dbjcv1TMeta?.path ?? "about",
    meta: aboutzL6dbjcv1TMeta || {},
    alias: aboutzL6dbjcv1TMeta?.alias || [],
    redirect: aboutzL6dbjcv1TMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsRJHDZhNaEPMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsRJHDZhNaEPMeta?.path ?? "events",
    meta: eventsRJHDZhNaEPMeta || {},
    alias: eventsRJHDZhNaEPMeta?.alias || [],
    redirect: eventsRJHDZhNaEPMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93hXFg4J2ZzFMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93hXFg4J2ZzFMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93hXFg4J2ZzFMeta || {},
    alias: _91media_id_93hXFg4J2ZzFMeta?.alias || [],
    redirect: _91media_id_93hXFg4J2ZzFMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample3Mkx9ZUKj0Meta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sample3Mkx9ZUKj0Meta?.path ?? "free-sample",
    meta: free_45sample3Mkx9ZUKj0Meta || {},
    alias: free_45sample3Mkx9ZUKj0Meta?.alias || [],
    redirect: free_45sample3Mkx9ZUKj0Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products5gzsCRrHzQMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45products5gzsCRrHzQMeta?.path ?? "included-products",
    meta: included_45products5gzsCRrHzQMeta || {},
    alias: included_45products5gzsCRrHzQMeta?.alias || [],
    redirect: included_45products5gzsCRrHzQMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_937LUUIFaYPgMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_937LUUIFaYPgMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_937LUUIFaYPgMeta || {},
    alias: _91media_id_937LUUIFaYPgMeta?.alias || [],
    redirect: _91media_id_937LUUIFaYPgMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view5sJqjGoTJ8Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: view5sJqjGoTJ8Meta?.path ?? "lessons/:lesson_id()/view",
    meta: view5sJqjGoTJ8Meta || {},
    alias: view5sJqjGoTJ8Meta?.alias || [],
    redirect: view5sJqjGoTJ8Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexrdfjkdaF38Meta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexrdfjkdaF38Meta?.path ?? "lessons",
    meta: indexrdfjkdaF38Meta || {},
    alias: indexrdfjkdaF38Meta?.alias || [],
    redirect: indexrdfjkdaF38Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93tCcJi9ibGHMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93tCcJi9ibGHMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93tCcJi9ibGHMeta || {},
    alias: _91media_id_93tCcJi9ibGHMeta?.alias || [],
    redirect: _91media_id_93tCcJi9ibGHMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index1Y8Jigd3FjMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: index1Y8Jigd3FjMeta?.path ?? "playlists/:playlist_id()",
    meta: index1Y8Jigd3FjMeta || {},
    alias: index1Y8Jigd3FjMeta?.alias || [],
    redirect: index1Y8Jigd3FjMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93IEhVgmD9BNMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93IEhVgmD9BNMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93IEhVgmD9BNMeta || {},
    alias: _91media_id_93IEhVgmD9BNMeta?.alias || [],
    redirect: _91media_id_93IEhVgmD9BNMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexqcGv4qivP6Meta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexqcGv4qivP6Meta?.path ?? "playlists",
    meta: indexqcGv4qivP6Meta || {},
    alias: indexqcGv4qivP6Meta?.alias || [],
    redirect: indexqcGv4qivP6Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsiYqxzteerEMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsiYqxzteerEMeta?.path ?? "private-sessions",
    meta: private_45sessionsiYqxzteerEMeta || {},
    alias: private_45sessionsiYqxzteerEMeta?.alias || [],
    redirect: private_45sessionsiYqxzteerEMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsRd3YMgAod9Meta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsRd3YMgAod9Meta?.path ?? "recordings",
    meta: recordingsRd3YMgAod9Meta || {},
    alias: recordingsRd3YMgAod9Meta?.alias || [],
    redirect: recordingsRd3YMgAod9Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsPVWo33CLYCMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsPVWo33CLYCMeta?.path ?? "reviews",
    meta: reviewsPVWo33CLYCMeta || {},
    alias: reviewsPVWo33CLYCMeta?.alias || [],
    redirect: reviewsPVWo33CLYCMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexHrgUap51XUMeta?.name ?? "buy-product-product_id",
    path: indexHrgUap51XUMeta?.path ?? "/buy/product/:product_id()",
    meta: indexHrgUap51XUMeta || {},
    alias: indexHrgUap51XUMeta?.alias || [],
    redirect: indexHrgUap51XUMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirm0e2ukb5kD6Meta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirm0e2ukb5kD6Meta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirm0e2ukb5kD6Meta || {},
    alias: confirm0e2ukb5kD6Meta?.alias || [],
    redirect: confirm0e2ukb5kD6Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmcmKuoKy46qMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmcmKuoKy46qMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmcmKuoKy46qMeta || {},
    alias: confirmcmKuoKy46qMeta?.alias || [],
    redirect: confirmcmKuoKy46qMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarFEhZQt8hTRMeta?.name ?? "calendar",
    path: calendarFEhZQt8hTRMeta?.path ?? "/calendar",
    meta: calendarFEhZQt8hTRMeta || {},
    alias: calendarFEhZQt8hTRMeta?.alias || [],
    redirect: calendarFEhZQt8hTRMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatzI7oCAjXTCMeta?.name ?? "chat",
    path: chatzI7oCAjXTCMeta?.path ?? "/chat",
    meta: chatzI7oCAjXTCMeta || {},
    alias: chatzI7oCAjXTCMeta?.alias || [],
    redirect: chatzI7oCAjXTCMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93aWVVoeHjtCMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93aWVVoeHjtCMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93aWVVoeHjtCMeta || {},
    alias: _91group_id_93aWVVoeHjtCMeta?.alias || [],
    redirect: _91group_id_93aWVVoeHjtCMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutsUNhtsIMjFMeta?.name ?? "community-groups-group_id-about",
    path: aboutsUNhtsIMjFMeta?.path ?? "about",
    meta: aboutsUNhtsIMjFMeta || {},
    alias: aboutsUNhtsIMjFMeta?.alias || [],
    redirect: aboutsUNhtsIMjFMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedBVjMiyCYpCMeta?.name ?? "community-groups-group_id-feed",
    path: feedBVjMiyCYpCMeta?.path ?? "feed",
    meta: feedBVjMiyCYpCMeta || {},
    alias: feedBVjMiyCYpCMeta?.alias || [],
    redirect: feedBVjMiyCYpCMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersdVNsEdY9KbMeta?.name ?? "community-groups-group_id-members",
    path: membersdVNsEdY9KbMeta?.path ?? "members",
    meta: membersdVNsEdY9KbMeta || {},
    alias: membersdVNsEdY9KbMeta?.alias || [],
    redirect: membersdVNsEdY9KbMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editwm8Rc3FuXcMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editwm8Rc3FuXcMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editwm8Rc3FuXcMeta || {},
    alias: community_45profile_45editwm8Rc3FuXcMeta?.alias || [],
    redirect: community_45profile_45editwm8Rc3FuXcMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93pPWgaBvoJzMeta?.name ?? "community-profile-id",
    path: _91id_93pPWgaBvoJzMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93pPWgaBvoJzMeta || {},
    alias: _91id_93pPWgaBvoJzMeta?.alias || [],
    redirect: _91id_93pPWgaBvoJzMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communitySVCQQgPiZIMeta?.name ?? "community",
    path: communitySVCQQgPiZIMeta?.path ?? "/community",
    meta: communitySVCQQgPiZIMeta || {},
    alias: communitySVCQQgPiZIMeta?.alias || [],
    redirect: communitySVCQQgPiZIMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_930KirG82dhIMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_930KirG82dhIMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_930KirG82dhIMeta || {},
    alias: _91uuid_930KirG82dhIMeta?.alias || [],
    redirect: _91uuid_930KirG82dhIMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93WicbdM3leLMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93WicbdM3leLMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93WicbdM3leLMeta || {},
    alias: _91unique_id_93WicbdM3leLMeta?.alias || [],
    redirect: _91unique_id_93WicbdM3leLMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboard9TBXVxXfuXMeta?.name ?? "dashboard",
    path: dashboard9TBXVxXfuXMeta?.path ?? "/dashboard",
    meta: dashboard9TBXVxXfuXMeta || {},
    alias: dashboard9TBXVxXfuXMeta?.alias || [],
    redirect: dashboard9TBXVxXfuXMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: index8fr5Wy014MMeta?.name ?? "event-details-event_id",
    path: index8fr5Wy014MMeta?.path ?? "/event/details/:event_id()",
    meta: index8fr5Wy014MMeta || {},
    alias: index8fr5Wy014MMeta?.alias || [],
    redirect: index8fr5Wy014MMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkout5yAwwUOS9pMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkout5yAwwUOS9pMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkout5yAwwUOS9pMeta || {},
    alias: checkout5yAwwUOS9pMeta?.alias || [],
    redirect: checkout5yAwwUOS9pMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productIOiJWUuie9Meta?.name ?? "event-details-event_id-select-product",
    path: select_45productIOiJWUuie9Meta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productIOiJWUuie9Meta || {},
    alias: select_45productIOiJWUuie9Meta?.alias || [],
    redirect: select_45productIOiJWUuie9Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsgadYNYFDBlMeta?.name ?? "events",
    path: eventsgadYNYFDBlMeta?.path ?? "/events",
    meta: eventsgadYNYFDBlMeta || {},
    alias: eventsgadYNYFDBlMeta?.alias || [],
    redirect: eventsgadYNYFDBlMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93xjURLsQv7BMeta?.name ?? "gifts-uuid",
    path: _91uuid_93xjURLsQv7BMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93xjURLsQv7BMeta || {},
    alias: _91uuid_93xjURLsQv7BMeta?.alias || [],
    redirect: _91uuid_93xjURLsQv7BMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexSCYdXcbwtpMeta?.name ?? "gifts",
    path: indexSCYdXcbwtpMeta?.path ?? "/gifts",
    meta: indexSCYdXcbwtpMeta || {},
    alias: indexSCYdXcbwtpMeta?.alias || [],
    redirect: indexSCYdXcbwtpMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93zFOdLSiCh0Meta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93zFOdLSiCh0Meta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93zFOdLSiCh0Meta || {},
    alias: _91invitation_id_93zFOdLSiCh0Meta?.alias || [],
    redirect: _91invitation_id_93zFOdLSiCh0Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_9391HTMc7WgLMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_9391HTMc7WgLMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_9391HTMc7WgLMeta || {},
    alias: _91product_id_9391HTMc7WgLMeta?.alias || [],
    redirect: _91product_id_9391HTMc7WgLMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexUagp3ksqr2Meta?.name ?? "index",
    path: indexUagp3ksqr2Meta?.path ?? "/",
    meta: indexUagp3ksqr2Meta || {},
    alias: indexUagp3ksqr2Meta?.alias || [],
    redirect: indexUagp3ksqr2Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93tmeVfj9ITgMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93tmeVfj9ITgMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93tmeVfj9ITgMeta || {},
    alias: _91invitation_unique_id_93tmeVfj9ITgMeta?.alias || [],
    redirect: _91invitation_unique_id_93tmeVfj9ITgMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinnApj9eR1g6Meta?.name ?? "join",
    path: joinnApj9eR1g6Meta?.path ?? "/join",
    meta: joinnApj9eR1g6Meta || {},
    alias: joinnApj9eR1g6Meta?.alias || [],
    redirect: joinnApj9eR1g6Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginSFIwNITSHdMeta?.name ?? "login",
    path: loginSFIwNITSHdMeta?.path ?? "/login",
    meta: loginSFIwNITSHdMeta || {},
    alias: loginSFIwNITSHdMeta?.alias || [],
    redirect: loginSFIwNITSHdMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutPxUffrDM3VMeta?.name ?? "logout",
    path: logoutPxUffrDM3VMeta?.path ?? "/logout",
    meta: logoutPxUffrDM3VMeta || {},
    alias: logoutPxUffrDM3VMeta?.alias || [],
    redirect: logoutPxUffrDM3VMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93bFCnsGsutaMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93bFCnsGsutaMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93bFCnsGsutaMeta || {},
    alias: _91meeting_type_slug_93bFCnsGsutaMeta?.alias || [],
    redirect: _91meeting_type_slug_93bFCnsGsutaMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_937cmzG0IosMMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_937cmzG0IosMMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_937cmzG0IosMMeta || {},
    alias: _91meeting_unique_id_937cmzG0IosMMeta?.alias || [],
    redirect: _91meeting_unique_id_937cmzG0IosMMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93GbJSZHx0XtMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93GbJSZHx0XtMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93GbJSZHx0XtMeta || {},
    alias: _91meeting_unique_id_93GbJSZHx0XtMeta?.alias || [],
    redirect: _91meeting_unique_id_93GbJSZHx0XtMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesizqu9VGMEBMeta?.name ?? "my-favorites",
    path: my_45favoritesizqu9VGMEBMeta?.path ?? "/my-favorites",
    meta: my_45favoritesizqu9VGMEBMeta || {},
    alias: my_45favoritesizqu9VGMEBMeta?.alias || [],
    redirect: my_45favoritesizqu9VGMEBMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosmP4XtqtorIMeta?.name ?? "my-studios",
    path: my_45studiosmP4XtqtorIMeta?.path ?? "/my-studios",
    meta: my_45studiosmP4XtqtorIMeta || {},
    alias: my_45studiosmP4XtqtorIMeta?.alias || [],
    redirect: my_45studiosmP4XtqtorIMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinN9ax6h6hmEMeta?.name ?? "optin",
    path: optinN9ax6h6hmEMeta?.path ?? "/optin",
    meta: optinN9ax6h6hmEMeta || {},
    alias: optinN9ax6h6hmEMeta?.alias || [],
    redirect: optinN9ax6h6hmEMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93aWvelkobaeMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93aWvelkobaeMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93aWvelkobaeMeta || {},
    alias: _91episode_id_93aWvelkobaeMeta?.alias || [],
    redirect: _91episode_id_93aWvelkobaeMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexXzDhXpbB8AMeta?.name ?? "podcasts-podcast_id",
    path: indexXzDhXpbB8AMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexXzDhXpbB8AMeta || {},
    alias: indexXzDhXpbB8AMeta?.alias || [],
    redirect: indexXzDhXpbB8AMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexRICI8mWWF5Meta?.name ?? "podcasts",
    path: indexRICI8mWWF5Meta?.path ?? "/podcasts",
    meta: indexRICI8mWWF5Meta || {},
    alias: indexRICI8mWWF5Meta?.alias || [],
    redirect: indexRICI8mWWF5Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93Km9ZTzz2rpMeta?.name ?? "product-product_id",
    path: _91product_id_93Km9ZTzz2rpMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93Km9ZTzz2rpMeta || {},
    alias: _91product_id_93Km9ZTzz2rpMeta?.alias || [],
    redirect: _91product_id_93Km9ZTzz2rpMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutuPpejbz8G3Meta?.name ?? "product-product_id-about",
    path: aboutuPpejbz8G3Meta?.path ?? "about",
    meta: aboutuPpejbz8G3Meta || {},
    alias: aboutuPpejbz8G3Meta?.alias || [],
    redirect: aboutuPpejbz8G3Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45content0VXw1TdU8aMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45content0VXw1TdU8aMeta?.path ?? "digital-download-content",
    meta: digital_45download_45content0VXw1TdU8aMeta || {},
    alias: digital_45download_45content0VXw1TdU8aMeta?.alias || [],
    redirect: digital_45download_45content0VXw1TdU8aMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsdMUKHFRSLIMeta?.name ?? "product-product_id-events",
    path: eventsdMUKHFRSLIMeta?.path ?? "events",
    meta: eventsdMUKHFRSLIMeta || {},
    alias: eventsdMUKHFRSLIMeta?.alias || [],
    redirect: eventsdMUKHFRSLIMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93G7K2jttqWWMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93G7K2jttqWWMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93G7K2jttqWWMeta || {},
    alias: _91media_id_93G7K2jttqWWMeta?.alias || [],
    redirect: _91media_id_93G7K2jttqWWMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplelbrYO7V0jbMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplelbrYO7V0jbMeta?.path ?? "free-sample",
    meta: free_45samplelbrYO7V0jbMeta || {},
    alias: free_45samplelbrYO7V0jbMeta?.alias || [],
    redirect: free_45samplelbrYO7V0jbMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productstAZd4d1MEaMeta?.name ?? "product-product_id-included-products",
    path: included_45productstAZd4d1MEaMeta?.path ?? "included-products",
    meta: included_45productstAZd4d1MEaMeta || {},
    alias: included_45productstAZd4d1MEaMeta?.alias || [],
    redirect: included_45productstAZd4d1MEaMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_930TUIYaddVAMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_930TUIYaddVAMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_930TUIYaddVAMeta || {},
    alias: _91media_id_930TUIYaddVAMeta?.alias || [],
    redirect: _91media_id_930TUIYaddVAMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewxeHnFtquJGMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewxeHnFtquJGMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewxeHnFtquJGMeta || {},
    alias: viewxeHnFtquJGMeta?.alias || [],
    redirect: viewxeHnFtquJGMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index7jflFm5Y4IMeta?.name ?? "product-product_id-lessons",
    path: index7jflFm5Y4IMeta?.path ?? "lessons",
    meta: index7jflFm5Y4IMeta || {},
    alias: index7jflFm5Y4IMeta?.alias || [],
    redirect: index7jflFm5Y4IMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938LT7BxRnt9Meta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_938LT7BxRnt9Meta?.path ?? "media/:media_id()",
    meta: _91media_id_938LT7BxRnt9Meta || {},
    alias: _91media_id_938LT7BxRnt9Meta?.alias || [],
    redirect: _91media_id_938LT7BxRnt9Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexghpLJ2P8UqMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexghpLJ2P8UqMeta?.path ?? "playlists/:playlist_id()",
    meta: indexghpLJ2P8UqMeta || {},
    alias: indexghpLJ2P8UqMeta?.alias || [],
    redirect: indexghpLJ2P8UqMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_935hu1MQs3kmMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_935hu1MQs3kmMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_935hu1MQs3kmMeta || {},
    alias: _91media_id_935hu1MQs3kmMeta?.alias || [],
    redirect: _91media_id_935hu1MQs3kmMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexZ1cR83zT3XMeta?.name ?? "product-product_id-playlists",
    path: indexZ1cR83zT3XMeta?.path ?? "playlists",
    meta: indexZ1cR83zT3XMeta || {},
    alias: indexZ1cR83zT3XMeta?.alias || [],
    redirect: indexZ1cR83zT3XMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessions2dDiUYVWvwMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessions2dDiUYVWvwMeta?.path ?? "private-sessions",
    meta: private_45sessions2dDiUYVWvwMeta || {},
    alias: private_45sessions2dDiUYVWvwMeta?.alias || [],
    redirect: private_45sessions2dDiUYVWvwMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsjQlWEJLddBMeta?.name ?? "product-product_id-recordings",
    path: recordingsjQlWEJLddBMeta?.path ?? "recordings",
    meta: recordingsjQlWEJLddBMeta || {},
    alias: recordingsjQlWEJLddBMeta?.alias || [],
    redirect: recordingsjQlWEJLddBMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsv8vJun0SANMeta?.name ?? "product-product_id-reviews",
    path: reviewsv8vJun0SANMeta?.path ?? "reviews",
    meta: reviewsv8vJun0SANMeta || {},
    alias: reviewsv8vJun0SANMeta?.alias || [],
    redirect: reviewsv8vJun0SANMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexxIzAQadWRRMeta?.name ?? "product",
    path: indexxIzAQadWRRMeta?.path ?? "/product",
    meta: indexxIzAQadWRRMeta || {},
    alias: indexxIzAQadWRRMeta?.alias || [],
    redirect: indexxIzAQadWRRMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexbp89oZ7HaPMeta?.name ?? "profile",
    path: indexbp89oZ7HaPMeta?.path ?? "/profile",
    meta: indexbp89oZ7HaPMeta || {},
    alias: indexbp89oZ7HaPMeta?.alias || [],
    redirect: indexbp89oZ7HaPMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesxRvq2Vuo6EMeta?.name ?? "profile-purchases",
    path: purchasesxRvq2Vuo6EMeta?.path ?? "/profile/purchases",
    meta: purchasesxRvq2Vuo6EMeta || {},
    alias: purchasesxRvq2Vuo6EMeta?.alias || [],
    redirect: purchasesxRvq2Vuo6EMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsFT80ytd6Q5Meta?.name ?? "profile-redemptions",
    path: redemptionsFT80ytd6Q5Meta?.path ?? "/profile/redemptions",
    meta: redemptionsFT80ytd6Q5Meta || {},
    alias: redemptionsFT80ytd6Q5Meta?.alias || [],
    redirect: redemptionsFT80ytd6Q5Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93oATx07q8alMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93oATx07q8alMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93oATx07q8alMeta || {},
    alias: _91quiz_id_93oATx07q8alMeta?.alias || [],
    redirect: _91quiz_id_93oATx07q8alMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93uDS3kvjXTBMeta?.name ?? "reset-password-uid-token",
    path: _91token_93uDS3kvjXTBMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93uDS3kvjXTBMeta || {},
    alias: _91token_93uDS3kvjXTBMeta?.alias || [],
    redirect: _91token_93uDS3kvjXTBMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetfiR096vBnkMeta?.name ?? "reset",
    path: resetfiR096vBnkMeta?.path ?? "/reset",
    meta: resetfiR096vBnkMeta || {},
    alias: resetfiR096vBnkMeta?.alias || [],
    redirect: resetfiR096vBnkMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopkZhkXsR06TMeta?.name ?? "shop",
    path: shopkZhkXsR06TMeta?.path ?? "/shop",
    meta: shopkZhkXsR06TMeta || {},
    alias: shopkZhkXsR06TMeta?.alias || [],
    redirect: shopkZhkXsR06TMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupalO9ghSRF7Meta?.name ?? "signup",
    path: signupalO9ghSRF7Meta?.path ?? "/signup",
    meta: signupalO9ghSRF7Meta || {},
    alias: signupalO9ghSRF7Meta?.alias || [],
    redirect: signupalO9ghSRF7Meta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: livegqbt4TfMifMeta?.name ?? "streaming-event_id-live",
    path: livegqbt4TfMifMeta?.path ?? "/streaming/:event_id()/live",
    meta: livegqbt4TfMifMeta || {},
    alias: livegqbt4TfMifMeta?.alias || [],
    redirect: livegqbt4TfMifMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipshPujE78ltfMeta?.name ?? "tips",
    path: tipshPujE78ltfMeta?.path ?? "/tips",
    meta: tipshPujE78ltfMeta || {},
    alias: tipshPujE78ltfMeta?.alias || [],
    redirect: tipshPujE78ltfMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93tBjq4A2ZdGMeta?.name ?? "waiver-uuid",
    path: _91uuid_93tBjq4A2ZdGMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93tBjq4A2ZdGMeta || {},
    alias: _91uuid_93tBjq4A2ZdGMeta?.alias || [],
    redirect: _91uuid_93tBjq4A2ZdGMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactpwYxBI7i8WMeta?.name ?? "widgets-calendars-compact",
    path: compactpwYxBI7i8WMeta?.path ?? "/widgets/calendars/compact",
    meta: compactpwYxBI7i8WMeta || {},
    alias: compactpwYxBI7i8WMeta?.alias || [],
    redirect: compactpwYxBI7i8WMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullurkQ9Ol6MoMeta?.name ?? "widgets-calendars-full",
    path: fullurkQ9Ol6MoMeta?.path ?? "/widgets/calendars/full",
    meta: fullurkQ9Ol6MoMeta || {},
    alias: fullurkQ9Ol6MoMeta?.alias || [],
    redirect: fullurkQ9Ol6MoMeta?.redirect,
    component: () => import("/tmp/build_fab81756/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]